import { Component, OnInit, AfterViewChecked, Input } from '@angular/core'
import { CpmService } from '../../service/cpm.service'
import { Subscription } from 'rxjs/Subscription'
import { StoreService } from 'app/service/store.service'
import { environment } from '../../../environments/environment'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-trading-cash-balance-and-alert',
  templateUrl: './trading-cash-balance-and-alert.component.html',
  styleUrls: ['./trading-cash-balance-and-alert.component.scss']
})
export class TradingCashBalanceAndAlertComponent
  implements OnInit, AfterViewChecked {
  @Input() printPage
  @Input() isFullFactSheet
  subscription: Subscription
  cashBalanceResponse: Array<Object>
  tradingSignData = []
  symbol
  cashBalanceAndAlertData = []
  hiddenSignFlag = true
  hiddenCashBalanceFlag = true
  tradingSingHeader = [
    'Sign',
    'Posted date',
    'Lifted date ',
    'Price on posted (Baht)',
    'Price on lifted (Baht)'
  ]
  cashBalanceAndAlertHeader = ['Level', 'Start date', 'End date']

  constructor(
    private store: StoreService,
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params

    if (symbol !== undefined) {
      this.getAllsignPosting(symbol)
    }

    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.symbol = response['securitySymbol']
        this.getAllsignPosting(this.symbol)
      })
  }

  getAllsignPosting(symbol) {
    this.cpmService.getAllSignPosting(symbol).then(response => {
      this.cashBalanceResponse = response
      this.tradingSignData = this.getTradingSign()
      this.cashBalanceAndAlertData = this.getCashBalanceAndAlert()
      this.cashBalanceAndAlertData.sort((a, b) => (a.postdate < b.postdate ? 1 : a.postdate > b.postdate ? -1 : 0))
      // hide if items more than five by default
      this.hiddenSignFlag = true
      this.hiddenCashBalanceFlag = true
    })
  }

  ngAfterViewChecked() {
    if (this.tradingSignData.length > 5) {
      $('#tradingSignTable tbody tr td img:eq(4)').removeClass('hidden')
    }
    if (this.cashBalanceAndAlertData.length > 5) {
      $('#cashBalanceAndTradingAlertTable tbody tr td img:eq(4)').removeClass(
        'hidden'
      )
    }
    if (this.hiddenSignFlag) {
      $('#tradingSignTable tbody tr:nth-child(n+6)').hide()
    } else {
      $('#tradingSignTable tbody tr:nth-child(n+6)').show()
    }
    if (this.hiddenCashBalanceFlag) {
      $('#cashBalanceAndTradingAlertTable tbody tr:nth-child(n+6)').hide()
    } else {
      $('#cashBalanceAndTradingAlertTable tbody tr:nth-child(n+6)').show()
    }
  }

  getTradingSign() {
    return this.cashBalanceResponse.filter(
      x => isNaN(x['type']) && x['type'] !== 'Trading Alert'
    )
  }

  getCashBalanceAndAlert() {
    return this.treatCashBalance().concat(this.treatAlert())
  }

  treatCashBalance(): Array<Object> {
    return this.cashBalanceResponse.filter(x => !isNaN(x['type'])).map(x => {
      // we create new array to prevent pass bt reference problem
      const temp = Array<Object>(x)
      temp['type'] = 'Cash balance level '.concat(x['type'])
      temp['postdate'] = x['postdate']
      temp['liftDate'] = x['liftDate']
      return temp
    })
  }

  treatAlert(): Array<Object> {
    return this.cashBalanceResponse.filter(x => x['type'] === 'Trading Alert')
  }

  noTradingSignData() {
    return this.tradingSignData.length > 0 ? false : true
  }

  noCashBalanceAndAlertData() {
    return this.cashBalanceAndAlertData.length > 0 ? false : true
  }

  toggleHiddenSign() {
    this.hiddenSignFlag = !this.hiddenSignFlag
  }

  toggleHiddenCashBalance() {
    this.hiddenCashBalanceFlag = !this.hiddenCashBalanceFlag
  }

  hasNewsPosting(tradingSign) {
    return tradingSign.postNewsId !== null
  }

  downloadPdf(tradingSign) {
    window.open(
      `${environment.cpmBaseUrl}/download?type=news&id=${
      tradingSign.postNewsId
      }`,
      '_blank'
    )
  }
  checkRecordPriceZeroOrNull(record) {
    if (record === 0 || record === null) {
      return true
    } else {
      return false
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/trading-cash-balance-and-alert/trading-cash-balance-and-alert.component.ts